import axios, { AxiosInstance } from 'axios';
import { createSearchParams } from 'react-router-dom';

export interface User {
  id: number;
  name: string;
  global_id: string;
  effective_locale: string;
}

export interface IGetAccessTokenResponse {
  token: string;
  refresh_token: string;
  dsc_nome_usuario: string;
}

class CanvasService {
  private api: AxiosInstance;
  private api_url: string;
  private canvas_url: string;
  private canvas_client_id: string;
  private canvas_client_secret: string;
  private canvas_scope: string;
  private canvas_redirect_uri: string;

  constructor() {
    this.api_url = String(process.env.REACT_APP_REST_ENDPOINT);
    this.canvas_url = String(process.env.REACT_APP_CANVAS_URL);
    this.canvas_client_id = String(process.env.REACT_APP_CANVAS_CLIENT_ID);
    this.canvas_client_secret = String(process.env.REACT_APP_CANVAS_CLIENT_SECRET);
    this.canvas_scope = String(process.env.REACT_APP_CANVAS_SCOPE);
    this.canvas_redirect_uri = String(process.env.REACT_APP_CANVAS_REDIRECT_URI);

    this.api = axios.create({
      baseURL: this.api_url,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }

  public redirect_to_canvas_login() {
    const params = createSearchParams({
      client_id: this.canvas_client_id,
      scope: this.canvas_scope,
      redirect_uri: this.canvas_redirect_uri,
      response_type: 'code',
    });

    const url_autenticacao = `${this.canvas_url}/login/oauth2/auth?${params}`;

    window.location.href = url_autenticacao;
  }

  public async get_access_token(code: string): Promise<IGetAccessTokenResponse> {
    const params = createSearchParams({
      client_id: this.canvas_client_id,
      client_secret: this.canvas_client_secret,
      redirect_uri: this.canvas_redirect_uri,
      scope: this.canvas_scope,
      grant_type: 'authorization_code',
      code,
    });

    const { data } = await this.api.post<IGetAccessTokenResponse>('/oauth2/token', undefined, {
      params,
    });

    return data;
  }
}

export { CanvasService };
